// extracted by mini-css-extract-plugin
module.exports = {"comp":"SeeMuch_comp__1Ju2w"};